import { render, staticRenderFns } from "./PreviousStep.vue?vue&type=template&id=7200ed7b&scoped=true"
import script from "./PreviousStep.vue?vue&type=script&lang=js"
export * from "./PreviousStep.vue?vue&type=script&lang=js"
import style0 from "./PreviousStep.vue?vue&type=style&index=0&id=7200ed7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200ed7b",
  null
  
)

export default component.exports